import { useQuery } from 'react-query';

import {
  ContextsResponse,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetContexts = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  return useQuery<ContextsResponse | undefined, Error>(
    ['get-contexts'],
    () => api.getContexts(),
    {
      enabled: enabled,
    }
  );
};
